import type { EventType, IIntranetEvent } from '~/types/event'

import mypackage from '../../package.json'

import config from '~/config'
import { EVENT_API_VERSION } from '~/const'
import dayjs from '~/utils/dayjs'
import { request } from '~/utils/request'

interface Values {
  full_url: string
  page: string
  page_url: string
  query_params: Record<string, string>
}

export const sendEvent = ({ eventType, value }: { eventType: EventType; value: Values }): Promise<void> => {
  const now = dayjs()

  const event: IIntranetEvent = {
    event_type: eventType,
    format_version: `v${EVENT_API_VERSION}`,
    local_time: now.unix(),
    value: JSON.stringify(value),
    version: mypackage.version,
  }

  return request({
    data: event,
    method: 'POST',
    url: `${config.EVENTS_API}/event`,
  })
}
